<div class="logo__wrapper">
  <img src="assets/icon/activar.svg" />
</div>